export type DemoTutorialStep = 'idle' | 'ball' | 'controls' | 'path' | 'zoom' | 'done';

const DEMO_TUTORIAL_STEP_ORDER: readonly DemoTutorialStep[] = [
  'ball',
  'controls',
  'path',
  'zoom',
  'done',
] as const;

export function isDemoTutorialInputBlocked(step: DemoTutorialStep): boolean {
  return step !== 'idle' && step !== 'done';
}

export function isDemoTutorialActive(step: DemoTutorialStep): boolean {
  return step !== 'idle' && step !== 'done';
}

export function getNextDemoTutorialStep(step: DemoTutorialStep): DemoTutorialStep {
  const index = DEMO_TUTORIAL_STEP_ORDER.indexOf(step);
  if (index < 0 || index >= DEMO_TUTORIAL_STEP_ORDER.length - 1) {
    return 'done';
  }
  return DEMO_TUTORIAL_STEP_ORDER[index + 1];
}

/** DOM highlight for hint + arrow controls — true for controls step and path step. */
export function isDemoTutorialHighlightControlsStep(step: DemoTutorialStep): boolean {
  return step === 'controls' || step === 'path';
}
